import React, { useEffect, useState } from 'react'
import Footer from './footer'
import Navbar2 from './navbar2'
import { useLocation, useNavigate } from 'react-router-dom'
import { isLoggedIn } from "./../service/authService"; // Import the isLoggedIn function from your authService
import RegisterKit from './registerKit'
import { APIURL } from '../config'
import DynamicAccordion from './DynamicAccordion'
import { Spinner } from 'react-bootstrap'
import CustomerReport from './CustomerReport'
import CustomerReport1 from './CustomerReport1'

const Homepage = () => {
  const [isLoggedIn1, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const [isKitRegistered, setIsKitRegistered] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [years, setYears] = useState(null);
  const [surveyData, setSurveyData] = useState("");
  const [errorMessage, setErrorMessage] = useState('');
  const [kitData, setKitData] = useState(null);
  const [isShowSurvey, setIsShowSurvey] = useState(false);

  const [viewStack, setViewStack] = useState([]); // track previous states

const location = useLocation();
const cameFromAdmin = location.state?.fromAdmin;

useEffect(() => {
  if (cameFromAdmin) {
    console.log("User came from Admin screen");
    // Optional: Show special UI or handle back navigation logic
  }
}, [cameFromAdmin]);

useEffect(() => {
  const params = new URLSearchParams(location.search);
  const view = params.get('view');
  if (view === 'report' && kitData) {
    // Stay on report
  } else {
    setKitData(null); // Default to accordion
  }
}, [location.search]);

  //build
  const fetchSurveyByEmail = async (email) => {
    setIsLoading(true);
    try {
      const response = await fetch(APIURL + `/getSurveyByEmail?email=${encodeURIComponent(email)}`);
      console.log("Fetch response:", response);
      if (!response.ok) {
        throw new Error('Failed to fetch survey data');
      }
      const data = await response.json();
      setSurveyData(data?.data);
      const birthdayMilliseconds = data.data[0].Birthday / 1000;
      const Birthday = new Date(birthdayMilliseconds);
      const currentDate = new Date();
      const differenceInYears = currentDate.getFullYear() - Birthday.getFullYear();
      setYears(differenceInYears);
      setErrorMessage('');
      setIsLoading(false);


    } catch (error) {
      setErrorMessage('Failed to load survey data. Please try again.');
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setShow(false);
    navigate("/survey")
  };



const goBack = () => {
  setKitData(null);
  navigate('?view=accordion', { replace: false });
};


  const showSurveyForm = (data) => {
    setIsShowSurvey(true);
    navigate(`/survey/${data?.Kit_id}`);
  };

  useEffect(() => {
    const checkLoggedIn = async () => {
      const loggedIn = await isLoggedIn();
      setIsLoggedIn(loggedIn);
      if (!loggedIn) {
        navigate("/login", { replace: true });
      } else {
        setIsLoggedIn(true);
        const token = localStorage.getItem("userInfo");
        // Retrieve the is_kit_registered value from localStorage
        const userInfo = JSON.parse(token);

        console.log("User ccInfo:", userInfo);

        setIsKitRegistered(userInfo.is_kit_registered);
        fetchSurveyByEmail(userInfo.username || userInfo.email);
      }
    };
    checkLoggedIn();
  }, [navigate]);



const viewReport = (data) => {
  setKitData(data);
  navigate('?view=report', { replace: false }); // Adds to history
};

  

  return (
    <div>
      {isLoading ? (<>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <div style={{
          display: 'flex', // Use the Flexbox layout
          justifyContent: 'center', // Center horizontally
          alignItems: 'center', // Center vertically
          width: '100vw', // Full height of the viewport
        }}>
          <Spinner animation="border" variant="primary" style={{ width: '8rem', height: '8rem' }} />
        </div>
        <br></br>
        <br></br>
        <br></br>
        <br></br>

      </>
      ) : (
        <>
          <hr></hr>
          {surveyData ? (<>
            {!kitData ? (
              <DynamicAccordion
                accordionData={surveyData}
                viewReport={viewReport}
                showSurveyForm={showSurveyForm}
              />
            ) : (
              <>
                <CustomerReport1 kitData={kitData} goBack={goBack} />
              </>
            )

            }

            {/*  */}
          </>)
            : (
              navigate("/survey", { replace: true })
            )
          }
        </>)}

      <RegisterKit show={show} handleClose={handleClose} /> {/* Render the CustomModal with appropriate props */}
    </div>
  )
}

export default Homepage
